/**
 * @generated SignedSource<<02f1bef0869d151e01c84a9fc32515e9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type KeyCell$data = {
  readonly key: string;
  readonly " $fragmentType": "KeyCell";
};
export type KeyCell$key = {
  readonly " $data"?: KeyCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"KeyCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "KeyCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "c96c690db251a7165949c597cac93f0f";

export default node;
